import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
const _ = require('lodash');
import { FormControl } from '@angular/forms';
import Fuse from 'fuse.js';
import { Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { MasterConstants } from '../../constants/master-constants';

@Component({
  selector: 'app-typeahead',
  templateUrl: './typeahead.component.html',
  styleUrls: ['./typeahead.component.scss']
})
export class TypeaheadComponent implements OnInit {
  @Input() listData: Array<any> = [];
  @Input() searchPlaceHolder: string = "Minimum 3 chars required to search...";
  @Output() modelChange = new EventEmitter();
  @Output() textLengthDetect = new EventEmitter();

  txtCtrl: FormControl;
  filteredListData: Observable<any[]>;
  showAutocomplete: boolean = false;
  txtVal: string = ''

  constructor(
    private localStorageService: LocalStorageService
  ) {
    this.txtCtrl = new FormControl();
  }

  ngOnInit(): void {
    // set item description list for search        
    if (this.listData.length == 0 && this.localStorageService.get(MasterConstants.CPP_PRODNAME_SEARCH_OPTIONS)) {
      this.listData = JSON.parse(this.localStorageService.get(MasterConstants.CPP_PRODNAME_SEARCH_OPTIONS));
      this.listData = this.listData.map(a => a.id);
    }

    this.filteredListData = this.txtCtrl.valueChanges
      .pipe(
        debounceTime(200),
        startWith(''),
        map(val => val && val.length >= 2 ? this.filterOptions(val) : [])
      );
  }

  //fuseOptions = {
  // isCaseSensitive: false,
  // includeScore: false,
  // shouldSort: true,
  // includeMatches: false,
  // findAllMatches: false,
  // minMatchCharLength: 3,
  // location: 0,
  // threshold: 0.6,
  // distance: 100,
  // useExtendedSearch: false,
  // ignoreLocation: false,
  // ignoreFieldNorm: false,
  // fieldNormWeight: 1
  //};

  //FuzzySearch
  filterOptions(name: string) {
    var list;
    name = (name || '').trim();
    if (name && name != '' && name.length >= 3) {
      list = this.listData.filter(a => a.indexOf(name.trim().toLocaleUpperCase()) == 0);

      if (list.length <= 0) {
        var len = name.length >= 4 ? name.length - 2 : 2;
        const fuse = new Fuse(this.listData, { minMatchCharLength: len, threshold: 0.4 });
        list = fuse.search(name).map(a => a.item);
      }
      else {
        list = list.concat(this.listData.filter(a => a.indexOf(' ' + name.toLocaleUpperCase()) > 0));
      }
      return list;
    }
  }

  updatedVal(e) {
    e = (e || '').trim();
    if (e && e.length > 2) {
      this.showAutocomplete = true;
    } else {
      this.showAutocomplete = false;
    }
    this.textLengthDetect.emit(this.txtVal);
  }

  optionClick() {
    this.modelChange.emit(this.txtVal);
  }

  keyupEnter() {
    this.showAutocomplete = false;
    this.modelChange.emit(this.txtVal);
  }
}
